import { jsxs as l, jsx as o } from "react/jsx-runtime";
import { svgIconStyles as C } from "../svg-icon/SvgIcon.styles.js";
function a({
  label: e,
  className: i,
  size: r,
  ...t
}) {
  return /* @__PURE__ */ l(
    "svg",
    {
      viewBox: "0 0 24 24",
      fill: "none",
      "data-title": "favoriteFill",
      stroke: "none",
      role: "img",
      "aria-hidden": !e,
      focusable: "false",
      className: C({ className: i, size: r }),
      ...t,
      children: [
        e && /* @__PURE__ */ o("title", { children: e }),
        /* @__PURE__ */ o(
          "path",
          {
            d: "M11.72 4.96461C11.8214 5.05754 11.9149 5.14622 12 5.22898C12.0851 5.14622 12.1786 5.05754 12.28 4.96461C12.8102 4.4788 13.5714 3.86189 14.4767 3.36769C15.3785 2.87531 16.4666 2.48113 17.6355 2.5007C18.8284 2.52067 20.0414 2.97142 21.1562 4.05708C23.414 6.25596 23.4882 9.74074 21.9768 12.9842C20.4534 16.2531 17.2714 19.45 12.6667 21.3671C12.2412 21.5443 11.7588 21.5443 11.3333 21.3671C6.72866 19.45 3.54658 16.2531 2.02325 12.9842C0.51177 9.74074 0.58598 6.25596 2.84382 4.05708C3.95859 2.97142 5.17162 2.52067 6.36452 2.5007C7.53343 2.48113 8.62145 2.87531 9.52333 3.36769C10.4285 3.86189 11.1898 4.4788 11.72 4.96461Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}
export {
  a as FavoriteFillIcon,
  a as default
};
